/*
    FAQ search form for use in various places
    Added to: public js
    Used in: chat offline js
    Requires: sui-autocomplete
*/

(function(root) {
    var initAutocomplete = root.springSpace.sui.initAutocomplete;

    var faqSearchForm = {
        /**
         * * @prop {Number} id Id of search content item.
         */
        id: 0,
        /**
         * @prop {Number} iid Site instid
         */
        iid: 0,
        /**
         * @prop {String} apiDomain Target for autocomplete queries.
         */
        apiDomain: '',
        /**
         * @prop {Array} groupId Group limiters.
         */
        groupId: 0,
        /**
         * @prop {HTMLElement} form Search form element.
         */
        form: null,
        /**
         * @prop {Number} limit Limit of results to return.
         */
        limit: 10,
        /**
         * @prop {Object} autocomplete SUI Autocomplete object.
         */
        autocomplete: null,
        /**
         * Format the api's returned data into what we need for autocomplete.
         * @param {Object} data Data from the returned API request.
         * @return {Object}
         */
        autcompleteDataFormatCb: function(data) {
            var output = [];
            var results = data.results;
            results.forEach(function(result) {
                result.label = result.question;
                output.push(result);
            });
            return output;
        },
        /**
         * When an autocomplete options is selected
         * @param {HTMLElement} option LI element that was selected.
         */
        autocompleteSelectCb: function(option) {
            // save original input search text before autocomplete selection
            let originalQInput = this.form.querySelector('input[name=originalq]');
            if (originalQInput === null) {
                originalQInput = document.createElement('input');
                originalQInput.setAttribute('type', 'hidden');
                originalQInput.setAttribute('name', 'originalq');
                this.form.insertBefore(originalQInput, this.form.firstChild);
            }
            const searchInput = this.form.querySelector('#s-la-content-search-query-' + this.id);
            originalQInput.value = searchInput.dataset.oldvalue || '';

            var faqInput = this.form.querySelector('input[name=faqid]');
            if (faqInput === null) {
                faqInput = document.createElement('input');
                faqInput.setAttribute('type', 'hidden');
                faqInput.setAttribute('name', 'faqid');
                this.form.insertBefore(faqInput, this.form.firstChild);
            }
            faqInput.value = option.getAttribute('data-faqid');
            this.form.submit();
        },
        /**
         * Instantiate the autocomplete.
         */
        enableAutocomplete: function() {
            try {
                this.autocomplete = initAutocomplete({
                    inputSelector: '#s-la-content-search-query-' + this.id,
                    queryUrl: 'https://' + this.apiDomain + '/faq/searchpublic',
                    dataProcessor: this.autcompleteDataFormatCb.bind(this),
                    selectCallback: this.autocompleteSelectCb.bind(this),
                    queryData: {
                        rows: this.limit,
                        iid: this.iid,
                        group_ids: this.groupId
                    }
                });
            } catch (e) {
                console.log(e.message);
            }
        },
        /**
         * Instantiate the search form.
         * @param {Object} config Config settings.
         * @param {Number} config.contentId Id number of search box.
         * @param {Number} confid.iid Site Instid.
         * @param {String} config.apiDomain Domain to send queries to for autocomplete.
         * @param {Array} config.groupId Group id(s) for search limiter.
         * @param {Number} config.limit Number of autocomplete result to show.
         */
        init: function(config) {
            this.id = config.contentId;
            this.iid = config.iid;
            this.apiDomain = config.apiDomain;
            this.groupId = JSON.stringify(config.groupId); //we use JSON string to pass to API easier
            this.form = document.querySelector('#s-la-content-search-' + this.id + ' form');
            this.limit = (config.limit) ? config.limit : 10;

            this.enableAutocomplete();
        }
    };

    /**
     * Initialize a new autocomplete.
     * @param {Object} config Config object passed to autocomplete.init
     * @return {autocomplete}
     */
    var initFaqSearchForm = function(config) {
        var form = Object.create(faqSearchForm);
        form.init(config);
        return form;
    };

    root.springSpace = this.springSpace || {};
    root.springSpace.la = this.springSpace.la || {};
    root.springSpace.la.initFaqSearchForm = initFaqSearchForm;
})(this);
